<template>
  <span class="tweened-number">{{ tweeningValue }}</span>
</template>

<script>
export default {
  name: "animated-counter",
  props: {
    value: {
      type: Number,
      required: true
    },
    decimal: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      tweeningValue: 0
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.tween(oldValue, newValue)
    }
  },
  methods: {
    tween: function (startValue, endValue) {
      var vm = this
      function animate () {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }
      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 2000)
        .onUpdate(function (object) {
          var decimal = 0
          if(vm.decimal !== undefined) {
            decimal = vm.decimal
          }
          vm.tweeningValue = (object * endValue).toFixed(decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        })
        .start()

      animate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AnimatedCounter.vue